import { IconUsersGroup } from '@tabler/icons-react';
import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Group, Stack, Text } from '@zorro/web/design-system';
import {
  ReadonlyInsuredForm,
  useEnrollmentInsuredForm,
} from '@zorro/web/shared-ui';

type Props = {
  onboardingPeriodId: string;
  employerId: string;
  employeeId: string;
};

export const EmployeePageMembers = ({
  onboardingPeriodId,
  employerId,
  employeeId,
}: Props) => {
  const insuredForm = useEnrollmentInsuredForm({
    onboardingPeriodId,
    employeeId,
    employerId,
    isFinalizationMode: false,
    isEmployeeMode: false,
  });

  return (
    <Stack gap="xl">
      <Group gap="xs">
        <ThemeIcon color="indigo" size="32">
          <IconUsersGroup />
        </ThemeIcon>
        <Text fw={600} size="lg">
          Family members
        </Text>
      </Group>

      <ReadonlyInsuredForm
        insuredForm={insuredForm}
        onboardingPeriodId={onboardingPeriodId}
        accordionVariant="shadow"
        withAgeAtPlanStart
      />
    </Stack>
  );
};
